module.exports = __webpack_public_path__ + "img/msilogo.29fb0c3a.png";